import { render, staticRenderFns } from "./CompleteInfo.vue?vue&type=template&id=0b6ed755&scoped=true"
import script from "./CompleteInfo.vue?vue&type=script&lang=js"
export * from "./CompleteInfo.vue?vue&type=script&lang=js"
import style0 from "./CompleteInfo.vue?vue&type=style&index=0&id=0b6ed755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ed755",
  null
  
)

export default component.exports